import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Reveal } from "../components/motion";
import { api } from "../lib/api";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null)); }, [slug]);

  if (post === undefined) return <div className="flex justify-center py-40"><Loader2 className="w-8 h-8 animate-spin text-emerald" /></div>;
  if (post === null) return (
    <div className="max-w-2xl mx-auto text-center py-40 px-5">
      <h1 className="font-serif text-4xl text-emerald">Article not found</h1>
      <Link to="/blog" className="inline-flex items-center gap-2 mt-6 text-emerald hover-underline"><ArrowLeft className="w-4 h-4" /> Back to blog</Link>
    </div>
  );

  return (
    <article data-testid="blog-post-page">
      <section className="relative h-[60vh] min-h-[400px] overflow-hidden bg-emerald-dark flex items-end">
        <img src={post.cover_image} alt={post.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-dark/90 via-emerald-dark/40 to-black/30" />
        <div className="relative z-10 max-w-[900px] mx-auto w-full px-5 lg:px-10 pb-16">
          <span className="eyebrow text-gold-light">{post.category} · {post.author}</span>
          <h1 className="font-serif text-cream font-light text-4xl lg:text-6xl leading-tight mt-4">{post.title}</h1>
        </div>
      </section>
      <div className="max-w-[760px] mx-auto px-5 lg:px-10 py-20">
        <Link to="/blog" className="inline-flex items-center gap-2 text-emerald hover-underline text-sm mb-10" data-testid="back-to-blog"><ArrowLeft className="w-4 h-4" /> All articles</Link>
        <Reveal>
          <p className="font-serif text-2xl text-ink/70 italic leading-relaxed mb-10">{post.excerpt}</p>
          <div className="prose max-w-none">
            {post.content.split("\n").filter(Boolean).map((para, i) => (
              <p key={i} className="text-ink/75 leading-relaxed mb-5 text-lg">{para}</p>
            ))}
          </div>
        </Reveal>
      </div>
    </article>
  );
}
